import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { ExportgridComponent } from '../../grid/exportgrid/exportgrid.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-stockrangereport',
  templateUrl: './stockrangereport.component.html',
  styleUrls: ['./stockrangereport.component.css']
})
export class StockrangereportComponent implements OnInit {

 
  @ViewChild('filterbar', { static: false }) filterbar;

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;
  isfilter: boolean = false;


  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;


  formname: string = "StockReport";


  gridformtype: string = "";

  checkemp: string = "";
  companycheckColl: any = [];
  filterstatus: string = "ALL";
  stockreportColl: any = [];
  dinetypeColl: any = [];
  groupColl: any = [];
  productColl: any = [];
  shiftColl: any = [];


  fromdate: any = new Date();
  todate: any = new Date();
  filterdinetypeid: number = null;
  filtergroupid: number = null;
  filterproductid: number = null;
  filtershiftid: number = null;

  searchtxt: any = "";

  columnDefs = [    
    { headerName: 'Rawmaterial', field: 'rawmaterialname' },
    { headerName: 'Opening Pcs', field: 'openingstockpcs'},
    { headerName: 'Opening ML', field: 'openingstockml' },
    { headerName: 'Purchase Pcs', field: 'inwardstockpcs' },
    { headerName: 'Purchase ML', field: 'inwardstockml' },
    { headerName: 'Closing Pcs', field: 'closingstockpcs' },    
    { headerName: 'Closing ML', field: 'closingstockml' },    
    { headerName: 'Sales Pcs', field: 'salesstockpcs' },
    { headerName: 'Sales ML', field: 'salesstockml' },
    { headerName: 'Total Pcs', field: 'totalstockpcs' },    
    { headerName: 'Total ML', field: 'totalstockml' },    
    // { headerName: 'Current Stock In Consumption Unit', field: 'consumptionstock' },
    // { headerName: 'Current Stock In Purchase Unit', field: 'purchasestock' },
    // // { headerName: 'Unit', field: 'uomname' },
    //  { headerName: 'Current Stock', field: 'currentstock',type:'decimal' },
  ]

  gridOptions = {
    enableactioncol: false,
    columnDefs: this.columnDefs,
  };

  dateCustomClasses: DatepickerDateCustomClasses[];


  constructor(private appService: DhukanDataService, public router: Router, private productFindService: NgbModal, private datePipe: DatePipe,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService, public loginService: LoginDataService) {
    this.fnServiceChanges();

    }

  //Company Check
  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          this.fnCheckPrivilage();
          if (this.isview) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }


  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          this.fnCheckPrivilage();
          if (this.isview) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnOnInitForm() {
    this.fngetStockReport();
    //this.fngetGroup();
    //this.fngetProduct();
   
  }


  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');


  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }




  fnActionExportClick() {
    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.stockreportColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {


    });
  }

  fngetGroup() {

    var data = {
      'groupid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getGroup(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.groupColl = res.json().result;

          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetProduct() {

    var data = {
      'productid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getProduct(data)
      .subscribe(
        (res) => {
          //console.log(res)
          if (res.json().status === 200) {
            this.productColl = res.json().result[0];
          

          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  //Get
  fngetStockReport() {
    var data = {
      'fromdate': this.fnFormatDatetime(this.fromdate),
      'todate': this.fnFormatDatetime(this.todate),
      'companyid': this.loginService.fnGetCompanyId(),
      'groupid': this.filtergroupid,
      'productid': this.filterproductid,
    }

    this.appService.getStockRangeReport(data)
      .subscribe(
        (res) => {
          console.log(res.json())

          if (res.json().status === 200) {
            this.stockreportColl = res.json().result;
            //console.log(this.stockreportColl)
        
          } else {
            
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }







  fnSetTable() {

  }

  private fnFocusTableRow(index, status) {
    if (index > -1) {
      if (status === 'IN') {
        this.stockreportColl[index].hoverfocus = "IN"
      }
      else {
        this.stockreportColl[index].hoverfocus = ""
      }
    }
  }

  fnTabHeaderClick(type) {
    this.searchtxt = "";
    this.gridformtype = type;
  }

  fnCloseForm() {
    try {
      this.router.navigate(['/Report']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnMomentDateTimeFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY hh:mm a');//  
    }
    else {
      return '';
    }

  }
  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }
  // private fnExport() {

  //   const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'l', backdrop: 'static' });
  //   modalRef.componentInstance.doctype = this.formname;
  //   modalRef.componentInstance.columnDefs = this.columnDefs;
  //   modalRef.componentInstance.contentColl = this.activitylogColl;
  //   modalRef.componentInstance.fnSetTable();
  //   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {


  //   });

  // }
  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }









}
